<template>
    <div class="chain-options__content">
        <div class="chain-options__select-options">
            <div class="label_chain_option">
                <label class="chain-options__label">{{ titleChainOption }} {{ displayCustomPrice(chainProducts[0]?.discount_amount) }} off</label>
                <SizeGuide data='chain'/>
            </div>
        </div>
        <div class="list_chain-options__select-chain active">
            <div class="chain-options__select-chain" v-for="(chainProduct, index) in chainProducts" :key="index" @click="is_active_option(index, $event)" :class="{ 'is_active_op': activeIndex === index }">
                <div class="chain-options__chain-product">
                    <div class="chain_checkbox">
                        <div class="option_checkbox"></div>
                    </div>   
                    <div class="chain-options__product-thumbnail" @click="show_engraving__modal(index)">
                        <img width="700" height="700" :src="chainProduct.product_image?.medium" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="" decoding="async">
                        <div class="chain-options__zoom-hover">
                        <img src="/single-product/zoom-icon.webp" alt="zoom-icon">
                        </div>
                    </div>
                    <div class="chain-options__product-details">
                        <a class="chain-options__product-title" :href="`${baseUrl}product/${chainProduct.slug}`">
                            <div class="title-chain">{{ chainProduct.name }}</div>
                        </a>
                        <div v-if="chainProduct.product_type == 'simple' && selectedChainPrice[index]" class="chain-options__product-price" :data-price="selectedChainPrice[index].price" :data-regular-price="selectedChainPrice[index].regular_price">
                            <span class="pt_new_price" v-if="selectedChainPrice[index]" v-html="displayCustomPrice(selectedChainPrice[index].price)"></span>
                            <span class="pt_cs_old_price" v-if="parseFloat(chainProduct.discount_amount) > 0 && selectedChainPrice[index]" v-html="displayCustomPrice(selectedChainPrice[index].regular_price)"></span>
                        </div>
                        <div v-if="chainProduct.product_type == 'variable' && selectedChainPrice[index]" class="chain-options__product-price" :data-price="selectedChainPrice[index].price" :data-regular-price="selectedChainPrice[index].regularPrice">
                            <span class="pt_new_price" v-if="selectedChainPrice[index]" v-html="displayCustomPrice(selectedChainPrice[index].price)"></span>
                            <span class="pt_cs_old_price" v-if="parseFloat(chainProduct.discount_amount) > 0 && selectedChainPrice[index]" v-html="displayCustomPrice(selectedChainPrice[index].regularPrice)"></span>
                        </div>
                        <div v-if="chainProduct.variations.length > 0" class="chain-options__select-variations">
                            <div class="chain-options__select-variation">
                                <ChainItem
                                    v-if="referenceArrayList[index]"
                                    :referenceArray="referenceArrayList[index]"
                                    :genarateLabel="genarateLabelList[index]"
                                    :isActive="isActiveList[index]"
                                    :reset="resetSignal" 
                                    @updatePrice="(prices) => handleChainPriceUpdate(prices, index)"
                                    @updateLabel="(label) => (genarateLabelList[index] = label)"
                                />
                            </div>
                        </div>
                        <input type="hidden" name="chain-options__product-id" id="chain-options__product-id" :value="chainProduct.id">
                        <input v-if="chainProduct.product_type === 'simple'" type="hidden" name="chain-options__product-simple-price" id="chain-options__product-simple-price" :value="chainProduct.price.price">
                    </div>
                </div>
                <div class="alt-engraving__modal " :id="'alt-engraving__modal_' + index">
                    <span class="alt-engraving__modal-close" @click="close_engraving__modal(index)">×</span>
                    <div class="alt-engraving__modal-image">
                        <img :src="chainProduct.product_image?.woocommerce_single" alt="" />
                    </div>
                </div>
            </div>
        </div>
        
    </div>
   
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_chain.scss";
</style>

<script setup lang="ts">
import { onMounted, ref, computed, watch } from 'vue'
import { displayPrice, displayCustomPrice } from '~/utils/displayPrice'
import ChainItem from './ChainItem.vue'
import SizeGuide from '~/components/Product/SingleProduct/Layouts/SizeGuide.vue'

const emit = defineEmits(['updatePrice'])
const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  priceInfo: {
    type: Object,
    required: true
  }
})

const runtimeConfig = useRuntimeConfig()
const baseUrl = runtimeConfig.public.BASE_URL
const wooStore = useWooStore()
const countryShort = wooStore.country?.country_short
const chainOptionData = computed(() => props.data)
const chainProducts = computed(() => chainOptionData.value.chainProduct ?? [])
const titleChainOption = computed(() => chainOptionData.value.titleChainOption ?? '')
const referenceArrayList = ref<Array<any[]>>([])
const genarateLabelList = ref<string[]>([])
const isActiveList = ref<boolean[]>([])
const chainProductPriceList = ref<any[]>([])
const previousSelectedIndexList = ref<(number | null)[]>([])

let initialPriceInfo = {
  price: props.priceInfo.price || 0,
  regular_price: props.priceInfo.regular_price || 0,
  sale_price: props.priceInfo.sale_price || null,
}

watch(
  () => props.priceInfo,
  (newPriceInfo) => {
    initialPriceInfo = {
      price: newPriceInfo.price || 0,
      regular_price: newPriceInfo.regular_price || 0,
      sale_price: newPriceInfo.sale_price || null
    }
  } 
)

const chainProductPrice = ref<number>(0)
const chainAdded = ref<boolean>(false)
const selectedChainPrice = ref<any[]>([])
const hasUpdatedPrice = ref<boolean[]>([])
const hasActivatedOption = ref<boolean[]>([])
const activeIndex = ref<number | null>(null);
const lastUpdatedIndex = ref<number | null>(null);
const originalPriceInfo = ref({ ...initialPriceInfo })
const check_last_index = ref<number>(0);


const handleChainPriceUpdate = (prices: any, index: number) => {
    chainProductPriceList.value[index] = prices;
    selectedChainPrice.value[index] = prices;

    var chainPrice: number = 0;
    var chainProductPrice: number = 0;
    
    const chainSelected = document.querySelector(".chain-options__select-chain.is_active_op") as HTMLElement;
    if (chainSelected) {
        
        const cPriceInfo = chainSelected.querySelector(".chain-options__product-price");
        if (cPriceInfo) {
            const price = parseFloat(cPriceInfo.getAttribute("data-price") || "0");
            const regularPrice = parseFloat(cPriceInfo.getAttribute("data-regular-price") || "0");
            if (!isNaN(price)) {
                chainPrice = price;
                chainProductPrice = regularPrice;
            }

        }
    }
    

    if (activeIndex.value === index) {
        emitPriceForIndex(index, chainPrice, chainProductPrice);
    }
}

const emitPriceForIndex = (index: number, chainPrice: number, chainProductPrice: number) => {
    const basePrice = Number(initialPriceInfo.price) || 0
    const baseRegularPrice = Number(initialPriceInfo.regular_price) || 0
    const baseSalePrice = initialPriceInfo.sale_price !== null
        ? Number(initialPriceInfo.sale_price)
        : null
    const addedPrice = chainProductPriceList.value[index];

    const updatedPriceInfo = {
        price: Number(basePrice) - chainPrice + addedPrice.price,
        regular_price: Number(baseRegularPrice) - chainProductPrice + (addedPrice.regularPrice || addedPrice.regular_price || 0),
        sale_price: baseSalePrice !== null
            ? Number(baseSalePrice) - chainPrice + (addedPrice.sale_price || addedPrice.price)
            : Number(basePrice) - chainPrice + addedPrice.price
    }

    emit('updatePrice', updatedPriceInfo)
}

const is_active_option = (index: number, event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (target.closest('.chain-options__select-variations')) return

    if (activeIndex.value === index) {
        reset_chain_option()
        return
    }

    let chainPrice: number = 0;
    let chainProductPrice: number = 0;

    const chainSelected = document.querySelector(".chain-options__select-chain.is_active_op") as HTMLElement;
    if (chainSelected) {
        const cPriceInfo = chainSelected.querySelector(".chain-options__product-price");
        if (cPriceInfo) {
            const price = parseFloat(cPriceInfo.getAttribute("data-price") || "0");
            const regularPrice = parseFloat(cPriceInfo.getAttribute("data-regular-price") || "0");
            if (!isNaN(price)) {
                chainPrice = price;
                chainProductPrice = regularPrice;
            }
        }
    }

    activeIndex.value = index;
    const addedPrice = chainProductPriceList.value[index];

    if (!addedPrice) {
        emit('updatePrice', {
            price: Number(initialPriceInfo.price),
            regular_price: Number(initialPriceInfo.regular_price),
            sale_price: initialPriceInfo.sale_price !== null
                ? Number(initialPriceInfo.sale_price)
                : null
        })
    } else {
        emit('updatePrice', {
            price: Number(initialPriceInfo.price) - Number(chainPrice) + Number(addedPrice.price),
            regular_price: Number(initialPriceInfo.regular_price) - chainProductPrice + (addedPrice.regularPrice || parseFloat(addedPrice.regular_price) || 0),
            sale_price: initialPriceInfo.sale_price !== null
                ? Number(initialPriceInfo.sale_price) - chainPrice + parseFloat(addedPrice.price)
                : Number(initialPriceInfo.price) - chainPrice + parseFloat(addedPrice.price)
        })
    }
}
const show_engraving__modal = (index: number) => {
    const showengravingModal = document.querySelector(`#alt-engraving__modal_${index}`);
    if (showengravingModal) {
        showengravingModal.classList.add("active");
    }
};
const close_engraving__modal = (index: number) => {
    const close_engraving__modal = document.querySelector(`#alt-engraving__modal_${index}`);
    if (close_engraving__modal) {
        close_engraving__modal.classList.remove("active");
    }
};
const resetSignal = ref(0);

const reset_chain_option = () => {
    if (activeIndex.value !== null) {
        const addedPrice = chainProductPriceList.value[activeIndex.value];

        const removeChainPrice = {
            price: Number(initialPriceInfo.price) - addedPrice.price,
            regular_price: Number(initialPriceInfo.regular_price) - (addedPrice.regularPrice || addedPrice.regular_price || 0),
            sale_price: Number(initialPriceInfo.sale_price) !== null
                ? Number(initialPriceInfo.sale_price) - (addedPrice.sale_price || addedPrice.price)
                : initialPriceInfo.price - addedPrice.price
        }
        emit('updatePrice', removeChainPrice)
    }else{
        emit('updatePrice', initialPriceInfo)
    }
  activeIndex.value = null
  resetSignal.value++ 

  chainProducts.value.forEach((_, index) => {
    // selectedChainPrice.value[index] = null
    // chainProductPriceList.value[index] = null
    genarateLabelList.value[index] = 'Select'
    isActiveList.value[index] = false
    previousSelectedIndexList.value[index] = null
  })
}


onMounted(() => {
    if (chainProducts.value.length > 0) {
        chainProducts.value.forEach((product, index) => {
            hasUpdatedPrice.value[index] = false
            hasActivatedOption.value[index] = false
            const children_data = product.variations || []
            selectedChainPrice.value[index] = product.price;
            const discountAmount = parseFloat(product.discount_amount) || 0;
            const refArr = children_data.map((child: any) => {
                const attrDetails = child.attrDetails?.[0] ?? {}
                const _label = []
                const _attribute = []

                for (const key in attrDetails) {
                const attribute = attrDetails[key]
                _label.push(attribute.label)
                _attribute.push(attribute.value.label)
                }

                return {
                    id: child.id,
                    name: _attribute.join(', '),
                    price: child.variationPrice.price,
                    prices: child.variationPrice,
                    discountAmount: discountAmount,
                    labels: _label.join(', '),
                    attributes: child?.attrs || {}
                }
            })

            referenceArrayList.value[index] = refArr
            genarateLabelList.value[index] = 'Select'
            isActiveList.value[index] = false
            chainProductPriceList.value[index] = null
            previousSelectedIndexList.value[index] = null
            if (refArr.length > 0) {
                const firstVariation = refArr[0]
                selectedChainPrice.value[index] = firstVariation.prices
                genarateLabelList.value[index] = firstVariation.labels
                chainProductPriceList.value[index] = firstVariation.prices
                // Nếu muốn active mặc định, cập nhật activeIndex
                // handleChainPriceUpdate(firstVariation.prices, index)
            } else {
                genarateLabelList.value[index] = 'Select'
                chainProductPriceList.value[index] = product.price
            }
        })
    }
})
</script>
